import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import form from './form'
import axios from 'axios'

axios.defaults.withCredentials = true
//axios.defaults.baseURL = 'http://localhost:8000'
axios.defaults.baseURL = process.env.VUE_APP_API_URI

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,
        form
    }
})